import React, { useEffect, useRef } from "react";

// SASS
import "./Part1.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import clockState1Img from "../../assets/img/clock-1-hands.svg";
import clockState2Img from "../../assets/img/dwell-time.png";
import clockState3Img from "../../assets/img/dwell-and-wet-time.png";
import sprayBottleImg from "../../assets/img/spray-bottle.svg";
import checkMarkImg from "../../assets/img/check-mark_2.svg";
import sparkleImg from "../../assets/img/sparkle_2.svg";
import sprayImg from "../../assets/img/spray.svg";
import clockHand from "../../assets/img/clock-1-hands.svg";

// FUNCTION EXPORT
export default function Part1({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: "750px", description: "fade in dwell time" },
    { stepNumber: "2", height: "750px", description: "fade in wet time" },
    { stepNumber: "4", height: "750px", description: "fade in spray" },
    { stepNumber: "5", height: null, description: "spacer" },
    { stepNumber: "6", height: null, description: "spacer" },
  ];

  // REFS
  const clockState2ImgEl = useRef(null);
  const clockState3ImgEl = useRef(null);
  const text1El = useRef(null);
  const text2El = useRef(null);
  const sprayEl = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeInOnEnter(clockState2ImgEl.current, direction);
            animate.fadeInOnEnter(text1El.current, direction);
            break;
          }
          case "2": {
            animate.fadeOutOnEnter(clockState2ImgEl.current, direction);
            animate.fadeInOnEnter(clockState3ImgEl.current, direction);
            animate.fadeInOnEnter(text2El.current, direction);
            break;
          }
          case "4": {
            // animate.fadeInOnEnter(sprayEl.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.fadeOutOnExit(clockState2ImgEl.current, direction);
            animate.fadeOutOnExit(text1El.current, direction);
            break;
          }
          case "2": {
            animate.fadeInOnExit(clockState2ImgEl.current, direction);
            animate.fadeOutOnExit(clockState3ImgEl.current, direction);
            animate.fadeOutOnExit(text1El.current, direction);
            break;
          }
          case "4": {
            // animate.fadeOutOnExit(sprayEl.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part1">
          <div className="part1__wrapper">
            <div className="text">
              To disinfect correctly, we need to understand{" "}
              <strong>contact time.</strong>
            </div>
            <div className="clock">
              <div className="clock__text">Contact time…</div>
              <div className="clock__img clock__img--state1">
                <img src={clockState1Img} alt="" className="img-fluid" />
              </div>
              <div
                className="clock__img clock__img--state2"
                ref={clockState2ImgEl}
              >
                <img src={clockState2Img} alt="" className="img-fluid" />
              </div>
              <div
                className="clock__img clock__img--state3"
                ref={clockState3ImgEl}
              >
                <img src={clockState3Img} alt="" className="img-fluid" />
              </div>
              <div className="white-text white-text-1" ref={text1El}>
                DWELL <br />
                TIME
              </div>
              <div className="white-text white-text-2" ref={text2El}>
                {" "}
                <span>or</span> <br /> WET <br /> TIME
              </div>
              {/* <div className="clock-hand"><img src={clockHand} alt="" className="img-fluid" /></div> */}
            </div>
            <div className="text">
              is the amount of time a disinfectant needs to do its job.
            </div>
            <div className="spray-container">
              <div className="spray-container__spray-bottle">
                <img src={sprayBottleImg} alt="" className="img-fluid" />
                <div className="spray-wrap sprayRightToLeft">
                  <img src={sprayImg} alt="" className="img-fluid" />
                </div>
              </div>
              <div className="spray-container__background"></div>
              <div className="spray-container__checkmark">
                <img src={checkMarkImg} alt="" className="img-fluid" />
              </div>
              <div className="spray-container__sparkle">
                <img src={sparkleImg} alt="" className="img-fluid" />
              </div>
              {/* <div className="spray-container__spray" ref={sprayEl}>
   
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
